import type { PartnerBrand } from "./types";

export const DEFAULT_PARTNER = "commercebuild";

const DEFAULT_THEME = {
  primaryColor: "#6630b4",
  accentColor: "#43bea5",
  inkColor: "#222a39",
  softColor: "#cbcae3"
};

function makePartner(
  key: string,
  displayName: string,
  logoSrc: string,
  theme: Partial<Omit<PartnerBrand, "key" | "displayName" | "logoSrc">> = {}
): PartnerBrand {
  return {
    key,
    displayName,
    logoSrc,
    ...DEFAULT_THEME,
    ...theme
  };
}

const PARTNER_BRANDS: Record<string, PartnerBrand> = {
  commercebuild: makePartner("commercebuild", "Commercebuild", "/logos/commercebuild.png"),
  bmd: makePartner("bmd", "BMD", "/logos/bmd.svg", {
    primaryColor: "#0f6baf",
    accentColor: "#17b4d3",
    inkColor: "#1f2937",
    softColor: "#cedfeb"
  }),
  innovia: makePartner("innovia", "Innovia", "/logos/partners/innovia.png"),
  nextec: makePartner("nextec", "NexTec", "/logos/partners/nextec.png"),
  lsp: makePartner("lsp", "LSP", "/logos/partners/lsp.png"),
  vallestra: makePartner("vallestra", "Vallestra", "/logos/partners/vallestra.png"),
  bc: makePartner("bc", "BC", "/logos/partners/bc.png"),
  cfbs: makePartner("cfbs", "CFBS", "/logos/partners/cfbs.png"),
  pss: makePartner("pss", "PSS", "/logos/partners/pss.png"),
  wye: makePartner("wye", "WYE", "/logos/partners/wye.png"),
  websan: makePartner("websan", "WebSan", "/logos/partners/websan.png"),
  netatwork: makePartner("netatwork", "Net at Work", "/logos/partners/netatwork.png"),
  kerr: makePartner("kerr", "Kerr", "/logos/partners/kerr.png"),
  sage: makePartner("sage", "Sage", "/logos/partners/sage.png"),
  genatec: makePartner("genatec", "Genatec", "/logos/partners/genatec.png")
};

export function resolvePartnerBrand(partner: string | null | undefined): PartnerBrand {
  const key = (partner ?? "").toLowerCase();

  return PARTNER_BRANDS[key] ?? PARTNER_BRANDS[DEFAULT_PARTNER];
}

export function getPartnerOptions(): PartnerBrand[] {
  return Object.values(PARTNER_BRANDS);
}
